import { ColorsV3StatusName } from '../../../design-system/colors_v3'
import { useMemo } from 'react'
import { getPatientIdentityStatusLabel } from '../../../misc/patient.utilities'
import { IdentityStateLabel, type IdentityStatus } from '../../../model/Patient'

export const useGetIdentityState = (
  identityStatus: IdentityStatus,
): { label: string; color: ColorsV3StatusName } => {
  return useMemo(() => {
    const label = getPatientIdentityStatusLabel(
      identityStatus.showTrustedSource,
      identityStatus.suspicious || identityStatus.fictitious,
      identityStatus.insiStatus.checked === 'VALIDATED',
    )
    if (label === IdentityStateLabel.QUALIFIED) return { label, color: 'valid' }
    else if (label === IdentityStateLabel.VALIDATED) return { label, color: 'normal' }
    else if (label === IdentityStateLabel.INSI_CHECKED) return { label, color: 'info' }
    else return { label, color: 'warning' }
  }, [
    identityStatus.suspicious,
    identityStatus.fictitious,
    identityStatus.showTrustedSource,
    identityStatus.insiStatus,
  ])
}
